export default function BookingCTA() {
  return (
    <section className="relative py-24 px-6 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/1d4ef9f4df9497f8a641c4ed7208f099.jpg"
          alt="Burlington Property Maintenance and Construction"
          className="w-full h-full object-cover object-top"
          width="1920"
          height="700"
          loading="lazy"
          decoding="async"
        />
        <div className="absolute inset-0 bg-[#2B5741]/85"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <p className="text-[#C8A97E] text-xs font-bold tracking-[0.4em] uppercase mb-5">
          LIMITED AVAILABILITY
        </p>
        <h2
          className="text-white text-5xl font-bold leading-tight mb-6"
          style={{ fontFamily: 'Playfair Display, serif' }}
        >
          Now Booking for the<br />
          2026 Summer
        </h2>
        <p className="text-white/75 text-base mb-8 max-w-lg mx-auto" style={{ fontFamily: 'Inter, sans-serif' }}>
          Spots fill up fast — lock in your project now for the summer season. Whether it's maintenance,
          a new deck, or a full renovation, we're ready to get to work.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#contact"
            className="bg-[#C8A97E] text-white px-10 py-3.5 text-xs font-bold uppercase tracking-[0.2em] hover:bg-[#b8976a] transition-colors whitespace-nowrap rounded-md"
          >
            BOOK YOUR SPOT
          </a>
          <a
            href="tel:9058694676"
            className="flex items-center gap-2 border-2 border-white text-white px-10 py-3.5 text-xs font-bold uppercase tracking-[0.2em] hover:bg-white hover:text-[#2B5741] transition-colors whitespace-nowrap rounded-md"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-fill"></i>
            </div>
            905-869-4676
          </a>
        </div>
      </div>
    </section>
  );
}
